
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Preweddingresortnearyavatmal() {



  const cardData =
  {
    keyword: ' Pre-Wedding Resort Near Yavatmal',
    heading:  'Woodland Escape: Pre-Wedding Resort Near Yavatmal ',
    headingDescription: 'Woodland Escape Resort is the perfect choice for a pre-wedding resort near Yavatmal, offering a serene natural setting with lush greenery, open lawns and forest-fringed pathways where your pre-wedding moments can unfold beautifully. With scenic spots ideal for photo-shoots, cozy guest cottages for family and friends, and seamless arrangements for décor, catering and guest comfort, the resort ensures your pre-wedding events—from intimate captures to lively gatherings—are both elegant and memorable. Whether you’re planning a relaxed evening by nature or a vibrant pre-wedding function, Woodland Escape Resort near Yavatmal blends tranquility, style and nature into every frame of your celebration.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Pre-Wedding Resort Near Yavatmal",
      "description": "Discover beautiful pre-wedding resorts near Yavatmal ideal for capturing romantic moments amidst scenic surroundings. These resorts provide elegant venues, lush landscapes, and professional support to make your pre-wedding shoot memorable, with options for both day-long and overnight stays."
    },
    {
      "name": "Yavatmal Pre Wedding Shoot Resort",
      "description": "Plan your pre-wedding shoot in Yavatmal resorts offering well-maintained gardens, picturesque views, and stylish interiors. Perfect for couples seeking a charming location for photography, these resorts combine comfort, privacy, and breathtaking backdrops."
    },
    {
      "name": "Yavatmal Romantic Resort",
      "description": "Experience romantic settings in Yavatmal resorts designed for couples, with serene ambiance, cozy seating, and beautiful natural surroundings. Ideal for couples to relax, enjoy, and capture intimate moments in a peaceful and elegant environment."
    },
    {
      "name": "Yavatmal Outdoor Pre Wedding Resort",
      "description": "Opt for outdoor pre-wedding shoots at Yavatmal resorts with expansive gardens, scenic pathways, and open-air amenities. These resorts provide a natural and vibrant backdrop perfect for photography sessions filled with light, color, and creativity."
    },
    {
      "name": "Affordable Pre Wedding Resort Yavatmal",
      "description": "Explore budget-friendly pre-wedding resorts in Yavatmal that provide stunning locations and professional photography support without exceeding your budget. These resorts balance affordability with quality, ensuring a beautiful shoot experience for couples."
    },
    {
      "name": "Yavatmal Resort for Couple Shoot",
      "description": "Choose resorts in Yavatmal specifically catering to couple photography sessions, offering romantic corners, cozy settings, and photogenic landscapes. Perfect for capturing candid and posed moments in a private and elegant environment."
    },
    {
      "name": "Yavatmal Riverside Pre Wedding Resort",
      "description": "Enjoy pre-wedding shoots by riverside resorts in Yavatmal, featuring calm waters, lush greenery, and serene surroundings. These locations provide natural reflections and peaceful vistas, making every photo look enchanting and timeless."
    },
    {
      "name": "Yavatmal Hill Pre Wedding Resort",
      "description": "Capture stunning pre-wedding shots in hill resorts near Yavatmal with panoramic views, misty landscapes, and cool breezes. These resorts offer an elevated and unique setting for romantic and dramatic photography."
    },
    {
      "name": "Yavatmal Nature Pre Wedding Resort",
      "description": "Reconnect with nature at Yavatmal resorts ideal for pre-wedding shoots, surrounded by trees, gardens, and open spaces. These venues allow couples to enjoy the outdoors while creating natural, vibrant, and timeless photographs."
    },
    {
      "name": "Yavatmal Photography Resort",
      "description": "Select Yavatmal resorts optimized for professional pre-wedding photography, offering well-maintained venues, flexible spaces, and aesthetic interiors. Perfect for photographers and couples looking to capture creative and memorable shots."
    },
    {
      "name": "Yavatmal Booking for Pre Wedding Shoot",
      "description": "Easily book your preferred resort in Yavatmal for a pre-wedding shoot online, securing the best locations, amenities, and support. Enjoy a hassle-free booking process that ensures your shoot is perfectly planned and stress-free."
    },
    {
      "name": "Yavatmal One Day Pre Wedding Resort",
      "description": "Plan a one-day pre-wedding shoot at Yavatmal resorts with full-day access, outdoor spaces, and convenient facilities. Ideal for couples looking for a focused, beautiful shoot without overnight commitments."
    },
    {
      "name": "Yavatmal Luxury Pre Wedding Resort",
      "description": "Indulge in luxurious pre-wedding resorts in Yavatmal with elegant architecture, premium interiors, and landscaped gardens. Perfect for couples seeking a high-end, visually stunning backdrop for their photos and memories."
    },
    {
      "name": "Yavatmal Resort Packages",
      "description": "Choose from curated resort packages in Yavatmal that include accommodations, photography setups, and additional services for a seamless pre-wedding experience. These packages ensure everything is organized for convenience and perfection."
    },
    {
      "name": "Yavatmal Couple Shoot Resort",
      "description": "Select resorts in Yavatmal dedicated to couple shoots, featuring romantic nooks, private spaces, and picturesque surroundings. Perfect for capturing intimate moments, styled photo sessions, and candid interactions in a natural and elegant setting."
    }
  ],
  "tableData": [
    ["- Pre-Wedding Resort Near Yavatmal", "- Yavatmal Pre Wedding Shoot Resort"],
    ["- Yavatmal Romantic Resort", "- Yavatmal Outdoor Pre Wedding Resort"],
    ["- Affordable Pre Wedding Resort Yavatmal", "- Yavatmal Resort for Couple Shoot"],
    ["- Yavatmal Riverside Pre Wedding Resort", "- Yavatmal Hill Pre Wedding Resort"],
    ["- Yavatmal Nature Pre Wedding Resort", "- Yavatmal Photography Resort"],
    ["- Yavatmal Booking for Pre Wedding Shoot", "- Yavatmal One Day Pre Wedding Resort"],
    ["- Yavatmal Luxury Pre Wedding Resort", "- Yavatmal Resort Packages"],
    ["- Yavatmal Couple Shoot Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Ideal Pre‑Wedding Venue Near Yavatmal",
    "WhyChoosedescription": "Woodland Escape Resort offers an enchanting location for your pre‑wedding celebrations near Yavatmal. Set amidst lush greenery, expansive lawns and tranquil natural surroundings, it provides a stunning backdrop for capturing elegant photos and unforgettable moments ahead of your big day."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Settings & Photo‑Friendly Spots",
    "WhyChoosedescription": "The resort features beautifully maintained open lawns, shaded tree‑lines, and nature‑laced pathways — perfect for pre‑wedding shoots, candid moments and romantic strolls. The ambience adds authenticity and charm to your celebratory visuals."
  },
  {
    "WhyChooseheading": "Private & Calm Ambience for Couple Moments",
    "WhyChoosedescription": "Woodland Escape Resort offers a serene and relatively secluded environment, allowing you and your partner to relax, interact and enjoy the moments with minimal outside distractions. This tranquility helps in creating meaningful pre‑wedding memories and comfortable photo‑sessions."
  },
  {
    "WhyChooseheading": "Spacious Event Ready Areas",
    "WhyChoosedescription": "With its broad lawns and well‑designed open spaces, the resort can easily host your pre‑wedding functions like engagement, pool‑side party, music get‑together or sundowner shoot. The flexibility in layout makes it convenient to personalise the setting to match your theme and vision."
  },
  {
    "WhyChooseheading": "Comfortable Guest Stay & Support Facilities",
    "WhyChoosedescription": "Your pre‑wedding group — whether it’s your close family, friends or photography team — can stay onsite or nearby, relax between sessions, freshen up in comfortable rooms and enjoy the resort’s amenities. This ensures the entire event flows smoothly without much travel between shots and events."
  },
  {
    "WhyChooseheading": "Tailored Services & Wedding‑Pre‑Wedding Assistance",
    "WhyChoosedescription": "From décor arrangement, lighting for evening shoots, catering for informal gatherings, to serving refreshments during breaks, Woodland Escape Resort can help craft the pre‑wedding experience for you. This support ensures you focus on the moment while the logistics get handled."
  },
  {
    "WhyChooseheading": "Convenient Location from Yavatmal",
    "WhyChoosedescription": "Situated within easy reach of Yavatmal, Woodland Escape Resort offers the advantage of accessible travel for guests while still delivering the feel of a destination‑escape. This balance makes it an effective choice for those wanting both convenience and charm."
  }
]
























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a pre‑wedding resort near Yavatmal?",
    answer: "Woodland Escape Resort is an ideal pre‑wedding destination near Yavatmal with its natural greenery, scenic open lawns, and tranquil surroundings—making it perfect for photo‑shoots, pre‑wedding events, and memorable gatherings."
  },
  {
    question: "How far is Woodland Escape Resort from Yavatmal city?",
    answer: "The resort is located within a comfortable driving distance from Yavatmal, making it convenient for couples and their families to plan a stress‑free pre‑wedding shoot or ceremony."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for pre‑wedding events?",
    answer: "The resort provides spacious outdoor lawns, elegant event spaces, options for customised décor, scenic corners ideal for photography, and comfortable stay‑arrangements for visiting guests."
  },
  {
    question: "Is Woodland Escape Resort suitable for gatherings of family & friends for pre‑wedding functions?",
    answer: "Yes! The resort is group‑friendly and family‑friendly, offering safe, comfortable and well‑maintained event zones where all guests can relax and enjoy the pre‑wedding festivities."
  },
  {
    question: "Does the resort provide catering and decoration services for pre‑wedding events?",
    answer: "Absolutely. Woodland Escape Resort can arrange catering, snacks and beverages and help with décor arrangements to make your pre‑wedding occasion seamless and memorable."
  },
  {
    question: "How can we book Woodland Escape Resort for a pre‑wedding event near Yavatmal?",
    answer: "You can contact the resort via phone or WhatsApp for reservations, or visit their official website. Booking in advance is recommended to secure the date and preferred setup."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patil, Yavatmal",
    text: "Our pre‑wedding shoot at Woodland Escape Resort was simply perfect! The greenery, open lawn spaces and staff support made it a memorable experience. Highly recommended near Yavatmal."
  },
  {
    name: "Ms. Shilpa & Mr. Rohit, Yavatmal",
    text: "We chose Woodland Escape Resort for our pre‑wedding function and loved it. The scenic setting and customised décor options exceeded our expectations. A top pre‑wedding resort near Yavatmal!"
  }
];





























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pre-Wedding Resort Near Yavatmal",
  "image": "https://woodlandescape.com/assets/images/yavatmal-pre-wedding-resort.jpg",
  "description": "Host your perfect pre-wedding shoot at Woodlandescape Resort near Yavatmal. Ideal for romantic outdoor shoots, riverside photography, hilltop settings, and luxury couple experiences.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "38"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/pre-wedding-resort-yavatmal"
  }
};



  return (
    <div>
<Helmet>
  <title>Pre-Wedding Resort Near Yavatmal | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Book the best pre-wedding resort near Yavatmal at Woodlandescape Resort. Perfect for romantic outdoor shoots, riverside or hilltop photography, luxury couple stays, and nature-friendly pre-wedding experiences." 
  />
  <meta 
    name="keywords" 
    content="Pre-Wedding Resort Near Yavatmal, Yavatmal Pre Wedding Shoot Resort, Yavatmal Romantic Resort, Yavatmal Outdoor Pre Wedding Resort, Affordable Pre Wedding Resort Yavatmal, Yavatmal Resort for Couple Shoot, Yavatmal Riverside Pre Wedding Resort, Yavatmal Hill Pre Wedding Resort, Yavatmal Nature Pre Wedding Resort, Yavatmal Photography Resort, Yavatmal Booking for Pre Wedding Shoot, Yavatmal One Day Pre Wedding Resort, Yavatmal Luxury Pre Wedding Resort, Yavatmal Resort Packages, Yavatmal Couple Shoot Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/47.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Preweddingresortnearyavatmal;